import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { message } from "antd";
import JobForm from "Components/Form/JobForm";
import { useInsertJobMutation } from "AppQuries/project/task";
import { jobCreationValidationSchema } from "core/Operations/ValidationSchema/projectValidationSchema";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
const AddTask = () => {
  const userData = useSelector(loggedInUser);
  const { mutate: addTask, isPending, isError, error } = useInsertJobMutation();
  const methods = useForm({
    defaultValues: {
      id: 0,
      jobCode: "",
      companyCode: userData.companyCode,
      locationCode: userData.locationCode,
      createUser: userData.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
      isActive: true,
    },
    resolver: yupResolver(jobCreationValidationSchema),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  console.log(errors);
  const onSubmit = (payload) => {
    const jobDetails = payload?.selectedEmployees?.map((emp) => ({
      id: 0,
      companyCode: userData?.companyCode,
      jobCode: "",
      employeeCode: emp,
      createUser: userData?.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData?.userName,
      modifyDate: getCurrentFormattedDate(),
      isActive: true,
    }));

    delete payload.selectedEmployees;

    payload.jobsDetails = jobDetails;
    const requestData = [{ ...payload }];

    addTask(requestData, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          toast.success("Task Added Successfully.");
          // setTimeout(() => {
            navigate(`${all_routes.project}${all_routes.task_list}`);
          // }, 1000);
        } else {
          toast.danger(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.danger(error.message || "Something went wrong.");
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add New Task</h4>
                    <h6>Add your new Task </h6>
                  </div>
                </div>

                
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Save Task</Tooltip>}
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.project}${all_routes.task_list}`}
                      className="btn  btn-secondary"
                    >
                      <BackIcon className="me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Add Task</h4>
                    </div>
                    <div className="card-body">
                      <JobForm mode="A" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddTask;
